module.exports = __webpack_public_path__ + "img/foods.600c84a4.svg";